import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const SearchInfo = ({ queryKey, clang, commonFilters }) => {
    const getCommonOptions = (commonFilters) => {
      const commonOptions = [];

      commonFilters.forEach(function(item) {
        if(item.options && item.options.filter(option => option.selected).length > 0) {
          commonOptions.push(item.options.filter(option => option.selected)[0]);
        }
      });

      return commonOptions;
    };

    return (
        <div className="search-info">
            <div className="search-info__content">
                {!getCommonOptions(commonFilters).length &&
                  <p className="search-info__key">
                    <span className="search-info__key-label">
                        {lang[clang].search.info}:
                    </span>
                    <strong>{queryKey}</strong>
                  </p>}
                {getCommonOptions(commonFilters).length > 0 &&
                    <p className="search-info__key">
                        {getCommonOptions(commonFilters).map((option, index) =>
                            <span key={index}>
                              <span className="search-info__key-label">
                                {lang[clang].search.about}
                                <span> {lang[clang].item.types.type[option.type]}: </span>
                              </span>
                              <strong>
                                <span className="search-info__key__phraze" key={index}>
                                  {option.description}
                                  {index !== getCommonOptions(commonFilters).length - 1 && <span>,</span>}
                                </span>
                              </strong>
                            </span>)}
                    </p>}
            </div>
        </div>
    );
};

SearchInfo.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SearchInfo);



// WEBPACK FOOTER //
// ./src/components/search/SearchInfo.js